import React, { createContext, useState, useContext } from 'react'

import PropTypes from 'prop-types'

import { TOAST_SHOW_TIME } from '@/utils/config'
import generateID from '@/utils/helpers/generateID'

import SnackbarContainer from '@/ui/SnackbarContainer'
import Toast from '@/ui/Toast'

export const SnackbarContext = createContext()

export const useSnackbar = () => useContext(SnackbarContext)

export let onToastMessage = () => {}

function SnackbarProvider({ children, ...props }) {
  const [toasts, setToasts] = useState([])

  const onToast = (message, variant = 'info') => {
    const id = generateID()
    const toast = {
      message,
      variant,
      id,
    }
    setToasts((toasts) => [...toasts, toast])
    setTimeout(() => {
      onRemove(id)
    }, TOAST_SHOW_TIME)
  }

  onToastMessage = onToast

  const onRemove = (removeID) => {
    setToasts((toasts) => toasts.filter(({ id }) => removeID !== id))
  }

  const value = {
    onToast,
    onRemove,
  }

  return (
    <SnackbarContext.Provider value={value} {...props}>
      {children}
      <SnackbarContainer>
        {toasts.map(({ id, ...toastProps }) => (
          <Toast
            key={`toast-${id}`}
            id={id}
            onRemove={onRemove}
            {...toastProps}
          />
        ))}
      </SnackbarContainer>
    </SnackbarContext.Provider>
  )
}

SnackbarProvider.propTypes = {
  children: PropTypes.any,
}

export default SnackbarProvider
